module.exports = __webpack_public_path__ + "img/맥형아카데미_3.c4283d68.jpg";